module.exports = ".modal {\n  width: 800px; }\n\n.payment-label {\n  min-width: 250px;\n  margin-right: 24px;\n  display: -ms-inline-grid;\n  display: inline-grid; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-vendor/invoices-view/invoice-details/invoice-details.component.scss
// module id = ./src/app/pages/vendor/my-vendor/invoices-view/invoice-details/invoice-details.component.scss
// module chunks = main